
import { Component, Prop, Watch,Mixins} from 'vue-property-decorator';
import { NoticeProps } from "@/scripts/datatypes"
import { functions,auth} from "@/scripts/firebase"
import {updatePhoneNumber,PhoneAuthProvider,signInWithPhoneNumber,reauthenticateWithPhoneNumber,RecaptchaVerifier,ConfirmationResult} from 'firebase/auth'
import {httpsCallable} from 'firebase/functions'
import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common';
import { CheckAuthUserExistsArg } from '@/common-datatypes';

@Component({
  components: {
  }
})

export default class PhoneAuth extends Mixins(Common) {
	@Prop({type: Boolean,default: false}) private isShow!: boolean;
	@Prop({type: String,default: 'signIn'}) private type!: 'signIn' | 'reAuth' | 'update' | 'signUp'
  isLoading = false
  phoneNumber = ''
  phoneObject = {number: '',valid: false,formatted: ''}
  telInputShowFlags = false
  recaptchaVerifier?: RecaptchaVerifier
  recaptchaVerified =  false
  recaptchaWidgetId =  0
  verificationCode = ''
  confirmationResult?: ConfirmationResult
  verificationId = ''
  notice = {} as NoticeProps
  sentVerificationCode = false
  
  get observerSignIn(){
    return this.$refs.signInCellPhoneValidationObserver as InstanceType<typeof ValidationObserver>;
  }
 
  get observerVerifyPhoneNumber(){
    return this.$refs.verifyPhoneNumberValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get isDisabled(){
    return (this.phoneObject.valid && this.recaptchaVerified) ? false : true
  }

  get isDisabledVerifyPhoneNumber(){
    return this.verificationCode ? false : true
  }

  @Watch('verificationCode')
  changeVerificationCode(code: string){
    if(/^\d{6}$/.test(code)){
      this.verifyPhoneNumber()
    }
  }

  async created(){
    console.trace('created');
    this.phoneNumber = (this.$store.state.user && this.$store.state.user.phoneNumber) ? this.$store.state.user.phoneNumber : ''
  }

  public inputPhoneNumber(number: string, phoneObject: {number: string; valid: boolean; formatted: string}){
    this.phoneObject = phoneObject
    this.observerSignIn.reset()
  }

  public async returnToInputPhoneNumber(){
    this.sentVerificationCode = false
    this.constructRecaptcha()
    this.verificationCode = ''
    this.verificationId = ''
    this.confirmationResult = undefined
    this.observerVerifyPhoneNumber.reset()
  }

  async mounted(){
    console.trace('mounted')
    this.constructRecaptcha()
  }

  public async constructRecaptcha(){
    this.recaptchaVerifier?.clear()
    this.recaptchaVerifier = new RecaptchaVerifier(
      "recaptcha-container",{
        theme: 'light',
        size: 'normal',
        tabindex: 0,
        callback: () => {
          this.recaptchaVerified = true
          this.observerSignIn.setErrors({
            reCAPTCHA: ''
          })
        },
        "expired-callback": () => {
          this.observerSignIn.setErrors({
            reCAPTCHA: this.$t('authentication.reCAPTCHA.expired') as string
          })
          this.recaptchaVerified = false
        },
        "error-callback": () => {
          this.observerSignIn.setErrors({
            reCAPTCHA: this.$t('authentication.reCAPTCHA.error') as string
          })
          this.recaptchaVerified = false
        }
      },
      auth
    );

    this.recaptchaWidgetId = await this.recaptchaVerifier.render();
  }

  destroyed() {
    console.trace('destroyed');
  }

  public async sendCode() {
    try{
      this.notice = {
        isShow: false,
      }

      if(! this.recaptchaVerifier || ! this.recaptchaVerified){
        if(! this.recaptchaVerified){
          this.observerSignIn.setErrors({
            reCAPTCHA: this.$t('authentication.reCAPTCHA.required') as string
          })
        }
        return
      }

      if(! this.phoneObject.valid || ! await this.observerSignIn.validate()){
        if(! this.phoneObject.valid){
          this.observerSignIn.setErrors({
            phoneNumber: this.$t('authentication.errorCode.auth/invalid-phone-number') as string
          })
        }
        return
      }

      this.$store.commit("setLoading",true);
      this.isLoading = true

      const checkAuthUserExists = httpsCallable(functions,'checkAuthUserExists')
      const existsAuthUser = await checkAuthUserExists({identifier: this.phoneObject.number, type: 'phoneNumber'} as CheckAuthUserExistsArg)
        
      if(existsAuthUser.data && ['signUp','update'].includes(this.type)){
        this.observerSignIn.setErrors({
          phoneNumber: this.$t('phoneAuth.phoneNumberUsed') as string
        })
        this.constructRecaptcha()
        this.$store.commit("setLoading",false);
        this.isLoading = false
        return
      }

      if(! existsAuthUser.data && ['reAuth','signIn'].includes(this.type) ){
        this.observerSignIn.setErrors({
          phoneNumber: this.$t('phoneAuth.notFound') as string
        })
        this.constructRecaptcha()
        this.$store.commit("setLoading",false);
        this.isLoading = false
        return
      }

      if(auth.currentUser && this.type === 'reAuth'){
        this.confirmationResult = await reauthenticateWithPhoneNumber(auth.currentUser,this.phoneObject.number, this.recaptchaVerifier)
      }else if(auth.currentUser && this.type === 'update'){
        const provider = new PhoneAuthProvider(auth);
        this.verificationId = await provider.verifyPhoneNumber(this.phoneObject.number, this.recaptchaVerifier)
      }else{
        this.confirmationResult = await signInWithPhoneNumber(auth,this.phoneObject.number, this.recaptchaVerifier)
      }

      this.sentVerificationCode = true
      this.notice = {
        message: this.$t('phoneAuth.sentVerificationCode',{phoneNumber: this.phoneObject.formatted}) as string,
        duration: 0,
        isShow: true,
        type: {'is-info': true}
      }

    }catch(error){
      console.table(error)

      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('phoneAuth.error') as string

      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){
        this.observerSignIn.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.recaptchaVerified = false
    }
  }

  public async verifyPhoneNumber() {
    try{
      this.notice = {
        isShow: false,
      }

      if(! await this.observerVerifyPhoneNumber.validate() || ! (this.verificationId || this.confirmationResult)){
        return
      }

      this.$store.commit("setLoading",true)
      this.isLoading = true
      
      if(this.confirmationResult){
        await this.confirmationResult.confirm(this.verificationCode)
      }else{
        if(! auth.currentUser){
          return
        }
        const credential = PhoneAuthProvider.credential(this.verificationId,this.verificationCode)
        await updatePhoneNumber(auth.currentUser,credential)
      }

      this.notice = {
        message: this.$t('phoneAuth.verifiedPhoneNumber') as string,
        duration: 0,
        isShow: true,
        type: {'is-success': true}
      }

      this.$emit("onResult", true)

      this.returnToInputPhoneNumber()

    }catch(error){
      this.$emit("onResult", false)

      console.table(error)

      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('phoneAuth.error') as string

      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){
        this.observerVerifyPhoneNumber.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}
